@if (dtypeForm) {
  <div class="flex flex-row flex-auto flex-wrap w-full">
    @for (column of dtypeForm.dType?.column; track column) {
      @if (insertBefore === column.name && insertTemplate) {
        <div class="w-full">
          <ng-container *ngTemplateOutlet="insertTemplate"></ng-container>
        </div>
      }
      @if (dtypeForm.fields[column.name]; as field) {
        @if (!field.hidden) {
          @if (field.browserOpts?.newLine) {
            <div class="w-full"></div>
          }
                <dtype-item [ngClass]="{
                        'w-full': field.browserOpts?.width === 'FULL' && field.type !== twoColumnsTable,
                        'w-1/2': field.browserOpts?.width === 'HALF',
                        'w-1/3': field.browserOpts?.width === 'THIRD',
                        'w-2/3': field.browserOpts?.width === 'TWO_THIRDS',
                        'w-1/4': field.browserOpts?.width === 'FOURTH',
                        'w-3/4': field.browserOpts?.width === 'THREE_FOURTHS',
                        'w-1/5': field.browserOpts?.width === 'FIFTH',
                        'w-2/5': field.browserOpts?.width === 'TWO_FIFTH',
                        'w-3/5': field.browserOpts?.width === 'THREE_FIFTHS',
                        'w-4/5': field.browserOpts?.width === 'FOUR_FIFTHS',
                        'w-1/6': field.browserOpts?.width === 'SIXTH',
                        'w-5/6': field.browserOpts?.width === 'FIVE_SIXTHS',
                        'px-2 py-2': !field.hidden && field.type !== embeddedItemUri && field.type !== embeddedItemCollectionUri
                    }" [field]="field" [isUpdate]="isUpdate"></dtype-item>
        }
      }
    }
  </div>
}